import { isValuePresent } from '@/bundles/App/helpers/isValuePresent';
import { Nullable } from '@/utils/types';
import { formatRawNumber } from '@/utils/filters';

export const getRangeFromToLabel = (value: Array<Nullable<number | string>>): string => {
  if (value.length === 0) {
    return '';
  }

  const [min, max] = value;

  if (!isValuePresent(min) && !isValuePresent(max)) {
    return '';
  }

  if (isValuePresent(min) && isValuePresent(max)) {
    return `From ${min} — To ${max}`;
  }

  if (isValuePresent(min)) {
    return `From ${min}`;
  }

  return `To ${max}`;
}

export const getNumbersFromRangeLabel = (label: string): [Nullable<number>, Nullable<number>] => {
  const hasFromAndTo = label.startsWith('From') && label.includes('— To'); // check getRangeFromToLabel function
  const hasOnlyFrom = label.startsWith('From');
  const hasOnlyTo = label.startsWith('To');

  if (hasFromAndTo) {
    const [from, to] = label.split('—').map(item => formatRawNumber(item));
    return [from, to];
  }

  if (hasOnlyFrom) {
    return [formatRawNumber(label), null];
  }

  if (hasOnlyTo) {
    return [null, formatRawNumber(label)];
  }

  return [null, null];
}
